import React from 'react';
import { useMutation } from '@tanstack/react-query';
import { updateEnvironmentVariablesAppQuery } from '../apis';
import { toast } from 'react-toastify';

const useUpdateEnvironments = () => {
  const mutationData = useMutation({
    mutationFn: updateEnvironmentVariablesAppQuery,
    onSuccess: (data) => {
      toast.success('Update environment variables successfully');
    },
    onError: (error) => {
      const message = error?.response?.data?.message ?? 'Server error';
      toast.error(message);
      console.error('Error Update environment variables:', error);
    },
  });

  return mutationData;
};

export default useUpdateEnvironments;
